import { getResolvedRef as e } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { deSerializeParameter as t, getExample as n, getExampleFromSchema as r, isParamDisabled as i, serializeContentValue as a, serializeDeepObjectStyle as o, serializeFormStyle as s, serializeFormStyleForCookies as c, serializePipeDelimitedStyle as l, serializeSimpleStyle as u, serializeSpaceDelimitedStyle as d } from "@scalar/workspace-store/request-example";
import { isObjectLike as f } from "@scalar/helpers/object/is-object";
//#region src/code-example/helpers/operation-to-har/process-parameters.ts
var p = (t) => (t ?? []).map((t) => e(t)).filter((e) => e !== void 0), m = (e) => "allowReserved" in e && e.allowReserved !== void 0 ? e.allowReserved : "schema" in e && e.schema && typeof e.schema == "object" && "allowReserved" in e.schema ? e.schema.allowReserved === !0 : !1, h = (e, t) => m(t) ? e : encodeURIComponent(e), g = (e) => {
	if (e.in === "header") return {
		style: "simple",
		explode: "explode" in e && e.explode !== void 0 && e.explode
	};
	if (e.in === "cookie") return {
		style: "form",
		explode: "explode" in e && e.explode !== void 0 ? e.explode : !0
	};
	let t = {
		path: "simple",
		query: "form",
		header: "simple",
		cookie: "form"
	}[e.in] ?? "form", n = "style" in e && e.style ? e.style : t;
	return {
		style: n,
		explode: "explode" in e && e.explode !== void 0 ? e.explode : n === "form"
	};
}, _ = (a, o, s, c) => {
	let l = n(a, o, s);
	if (i(a, l, c)) return;
	if (l?.value !== void 0) return t(l.value, a);
	if (!("schema" in a) || !a.schema) return;
	let u = a.in === "path" ? { emptyString: `{${a.name}}` } : {}, d = e(a.schema);
	return d ? r(d, u) : void 0;
}, v = ({ harRequest: e, parameters: t, example: n, defaultDisabled: r }) => {
	let i = [...e.headers], f = [...e.queryString], m = e.url, v = p(t);
	for (let t of v) {
		if (!t.in || !t.name) continue;
		let p = _(t, n, void 0, r);
		if (p === void 0) continue;
		let { style: v, explode: b } = g(t);
		switch (t.in) {
			case "path":
				m = y(m, t, p, v, b);
				break;
			case "query":
			case "querystring":
				if ("content" in t && t.content) {
					let e = a(p, Object.keys(t.content)[0] ?? "application/json");
					f.push({
						name: t.name,
						value: h(e, t)
					});
					break;
				}
				switch (v) {
					case "form": {
						let e = s(p, b);
						if (Array.isArray(e)) for (let n of e) {
							let e = n.key || t.name;
							f.push({
								name: e,
								value: h(String(n.value), t)
							});
						}
						else f.push({
							name: t.name,
							value: h(String(e), t)
						});
						break;
					}
					case "spaceDelimited": {
						let e = d(p);
						f.push({
							name: t.name,
							value: h(e, t)
						});
						break;
					}
					case "pipeDelimited": {
						let e = l(p);
						f.push({
							name: t.name,
							value: h(e, t)
						});
						break;
					}
					case "deepObject":
						if (Array.isArray(p)) {
							let e = s(p, !0);
							if (Array.isArray(e)) for (let n of e) {
								let e = n.key || t.name;
								f.push({
									name: e,
									value: h(String(n.value), t)
								});
							}
							else f.push({
								name: t.name,
								value: h(String(e), t)
							});
						} else {
							let e = o(t.name, p);
							for (let n of e) f.push({
								name: n.key,
								value: h(n.value, t)
							});
						}
						break;
					default: f.push({
						name: t.name,
						value: h(String(p), t)
					});
				}
				break;
			case "header": {
				let e = u(p, b);
				i.push({
					name: t.name,
					value: String(e)
				});
				break;
			}
			case "cookie": {
				let n = c(p, b);
				if (Array.isArray(n)) for (let r of n) {
					let n = r.key || t.name, i = r.value === null ? "null" : String(r.value);
					e.cookies.push({
						name: n,
						value: i
					});
				}
				else {
					let r = n === null ? "null" : String(n);
					e.cookies.push({
						name: t.name,
						value: r
					});
				}
				break;
			}
		}
	}
	return {
		url: m,
		headers: i,
		queryString: f,
		cookies: e.cookies
	};
}, y = (e, t, n, r, i) => {
	switch (r) {
		case "matrix":
			if (i) {
				if (Array.isArray(n)) {
					let r = n.map((e) => `${t.name}=${e}`).join(";");
					return e.replace(`{;${t.name}}`, `;${r}`);
				}
				if (f(n)) {
					let r = Object.entries(n).map(([e, t]) => `${e}=${t}`).join(";");
					return e.replace(`{;${t.name}}`, `;${r}`);
				}
				return e.replace(`{;${t.name}}`, `;${t.name}=${n}`);
			}
			if (Array.isArray(n)) return e.replace(`{;${t.name}}`, `;${t.name}=${n.join(",")}`);
			if (f(n)) {
				let r = Object.entries(n).map(([e, t]) => `${e},${t}`).join(",");
				return e.replace(`{;${t.name}}`, `;${t.name}=${r}`);
			}
			return e.replace(`{;${t.name}}`, `;${t.name}=${n}`);
		case "label":
			if (i) {
				if (Array.isArray(n)) return e.replace(`{.${t.name}}`, `.${n.join(".")}`);
				if (f(n)) {
					let r = Object.entries(n).map(([e, t]) => `${e}=${t}`).join(".");
					return e.replace(`{.${t.name}}`, `.${r}`);
				}
				return e.replace(`{.${t.name}}`, `.${n}`);
			}
			if (Array.isArray(n)) return e.replace(`{.${t.name}}`, `.${n.join(",")}`);
			if (f(n)) {
				let r = Object.entries(n).map(([e, t]) => `${e},${t}`).join(",");
				return e.replace(`{.${t.name}}`, `.${r}`);
			}
			return e.replace(`{.${t.name}}`, `.${n}`);
		case "simple": {
			let r = u(n, i);
			return e.replace(`{${t.name}}`, String(r));
		}
		default: return e.replace(`{${t.name}}`, String(n));
	}
};
//#endregion
export { v as processParameters };

//# sourceMappingURL=process-parameters.js.map